/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Generate the Slovenian FURS internal act as a PDF attachment based on the entity's active premises, devices, and numbering strategy.
 * @summary Download FURS internal act PDF
 */
export type generateFursInternalActPdfResponse200 = {
  data: Blob
  status: 200
}

export type generateFursInternalActPdfResponse400 = {
  data: Error
  status: 400
}

export type generateFursInternalActPdfResponse401 = {
  data: Error
  status: 401
}

export type generateFursInternalActPdfResponse403 = {
  data: Error
  status: 403
}

export type generateFursInternalActPdfResponse404 = {
  data: Error
  status: 404
}

export type generateFursInternalActPdfResponse422 = {
  data: ValidationError
  status: 422
}

export type generateFursInternalActPdfResponse500 = {
  data: Error
  status: 500
}

export type generateFursInternalActPdfResponseSuccess = (generateFursInternalActPdfResponse200) & {
  headers: Headers;
};
export type generateFursInternalActPdfResponseError = (generateFursInternalActPdfResponse400 | generateFursInternalActPdfResponse401 | generateFursInternalActPdfResponse403 | generateFursInternalActPdfResponse404 | generateFursInternalActPdfResponse422 | generateFursInternalActPdfResponse500) & {
  headers: Headers;
};

export type generateFursInternalActPdfResponse = (generateFursInternalActPdfResponseSuccess | generateFursInternalActPdfResponseError)

export const getGenerateFursInternalActPdfUrl = () => {


  

  return `/fiscalization/furs/internal-act/report.pdf`
}

export const generateFursInternalActPdf = async ( options?: RequestInit): Promise<generateFursInternalActPdfResponse> => {
  
  return customFetch<generateFursInternalActPdfResponse>(getGenerateFursInternalActPdfUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Generate the Slovenian FURS internal act as an editable DOCX attachment based on the entity's active premises, devices, and numbering strategy.
 * @summary Download FURS internal act DOCX
 */
export type generateFursInternalActDocxResponse200 = {
  data: Blob
  status: 200
}

export type generateFursInternalActDocxResponse400 = {
  data: Error
  status: 400
}

export type generateFursInternalActDocxResponse401 = {
  data: Error
  status: 401
}

export type generateFursInternalActDocxResponse403 = {
  data: Error
  status: 403
}

export type generateFursInternalActDocxResponse404 = {
  data: Error
  status: 404
}

export type generateFursInternalActDocxResponse422 = {
  data: ValidationError
  status: 422
}

export type generateFursInternalActDocxResponse500 = {
  data: Error
  status: 500
}

export type generateFursInternalActDocxResponseSuccess = (generateFursInternalActDocxResponse200) & {
  headers: Headers;
};
export type generateFursInternalActDocxResponseError = (generateFursInternalActDocxResponse400 | generateFursInternalActDocxResponse401 | generateFursInternalActDocxResponse403 | generateFursInternalActDocxResponse404 | generateFursInternalActDocxResponse422 | generateFursInternalActDocxResponse500) & {
  headers: Headers;
};

export type generateFursInternalActDocxResponse = (generateFursInternalActDocxResponseSuccess | generateFursInternalActDocxResponseError)

export const getGenerateFursInternalActDocxUrl = () => {


  

  return `/fiscalization/furs/internal-act/report.docx`
}

export const generateFursInternalActDocx = async ( options?: RequestInit): Promise<generateFursInternalActDocxResponse> => {
  
  return customFetch<generateFursInternalActDocxResponse>(getGenerateFursInternalActDocxUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

